import { getBonusxApiConfigV1 } from "../../common/bonusxApiConfig";
import { ApiClientAbstract } from "../ApiClient/ApiClientAbstract";
import { IApiClientService } from "../ApiClient/ApiClientService.interface";
import AxiosApiClientInstance from "../AxiosApiClientInstance/AxiosApiClientInstance";
import { IApiClientBonusxServiceRepository } from "./ApiClientBonusxServiceRepository.interface";
import { IServiceApiResponse } from "./interfaces/IServiceApiResponse.interface";

export class ApiClientBonusxServiceRepository extends ApiClientAbstract implements IApiClientBonusxServiceRepository {
  private readonly _SERVICES_BASE_URL = "/service";

  constructor(client: IApiClientService = new AxiosApiClientInstance(undefined, getBonusxApiConfigV1())) {
    super(client);
  }

  public async getServiceById(id: number) {
    const url = decodeURIComponent(`${this._SERVICES_BASE_URL}/${id}`);
    const { data = null } = await this.get<IServiceApiResponse>(url);

    if (!data) {
      throw this._genericException();
    }

    return data;
  }
}
